import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/permission/sub-pages";
import type { TPermission } from "components/permission/helpers/permission-types-helper";

interface IPermissionRouteProps {
    permission: TPermission | undefined;
}

const PermissionRoute: React.FC<IPermissionRouteProps> = ({ permission }) => {
    return (
        <Routes>
            <Route path="/" element={<SubPage.OverView permission={permission} />} />
        </Routes>
    );
};

export default PermissionRoute;